import styled from 'styled-components/macro';

export const Wrapper = styled.div`
    min-width: 50vw;
    margin-top: 10px;
`;

export const ChartWrapper = styled.div``;
